import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDraw: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="draw, sketch, scratch"><path d="M2.25 13.9897C10.7821 5.54933 14.2475 2.2388 16.2665 4.38617C19.0805 7.37874 4.62713 16.4615 8.62569 18.7676C11.9573 20.6876 17.3338 10.2123 19.5418 12.899C20.8444 14.4822 16.2665 17.9913 17.4853 19.7373C18.4604 21.134 20.7356 19.3488 21.75 18.2819" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconDraw;
